import { patchState, signalStoreFeature, type, withMethods } from '@ngrx/signals';
import { IRoleState } from './role.state';
import { AppRole } from '../../models/roles/app-role.model';
import { AppModule } from '../../models/roles/app-module.model';

export const withRoleStateMethods = signalStoreFeature(
    { state: type<IRoleState>() },
    withMethods((store) => ({
        setRoles: (roles: AppRole[]) => {
            patchState(store, { roles, loading: false, error: null });
        },
        addRole: (role: AppRole) => {
            patchState(store, { roles: [role, ...store.roles()], loading: false, error: null });
        },
        updateRole: (role: AppRole) => {
            patchState(store, {
                roles: store.roles().map((r) => (r.roleGuid === role.roleGuid ? role : r)),
                selectedRole: store.selectedRole()?.roleGuid === role.roleGuid ? role : store.selectedRole(),
                loading: false,
                error: null,
            });
        },
        removeRole: (roleGuid: string) => {
            patchState(store, {
                roles: store.roles().filter((r) => r.roleGuid !== roleGuid),
                loading: false,
                error: null,
            });
        },
        setSelectedRole: (role: AppRole | null) => {
            patchState(store, { selectedRole: role, loading: false, error: null });
        },
        setModules: (modules: AppModule[]) => {
            patchState(store, { modules, loading: false, error: null });
        },
        setError: (error: string) => {
            patchState(store, { error, loading: false });
        },
    }))
);
